import React from 'react'
import { TextField } from '@mui/material';

// Open the native date picker from a click. The click can land on the
// label/wrapper, so resolve the real <input>; label clicks re-dispatch a
// second click after the first call consumed the user activation, so
// showPicker() can throw NotAllowedError — swallow it (picker already open).
// `?.` also guards browsers without showPicker support.
export const showDatePicker = (e) => {
    const input = e.currentTarget.querySelector?.('input') || e.currentTarget;
    try {
        input?.showPicker?.();
    } catch {
        // NotAllowedError / picker already open — nothing to do
    }
};

// Helper function to render styled TextField
export const StyledTextField = ({
    isDate, label, name, numberType, value, onChange, error,
    required, inputBoxColor, children, inputProps,
    multiline = false, minRows = 1, passwordType, disabled
}) => {

    // ✅ Convert value safely to string to avoid CRASH
    const stringValue = value?.toString() || "";
    
    const handleKeyDown = (e) => {
        if (numberType) {
            const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
            const isNumberKey = /^\d$/.test(e.key);
            const isDotKey = e.key === '.';
            const hasDot = stringValue.includes('.');   // ✅ SAFE NOW
            // const isZero = e.key === '0' && (!stringValue || stringValue === '0'); // block leading 0

            if (!isNumberKey && !allowedKeys.includes(e.key) && (!isDotKey || hasDot)) {
                e.preventDefault();
            }
            // if (isZero) {
            //     e.preventDefault();
            // }
        }
    };

    const handlePaste = (e) => {
        if (numberType) {
            const pasted = e.clipboardData.getData('text');
            if (!/^\d*\.?\d*$/.test(pasted)) {
                e.preventDefault();
            }
        }
    };

    return (
        <TextField
            required={required}
            label={label}
            name={name}
            value={value}
            disabled={disabled}
            onChange={onChange}
            error={!!error}
            type={isDate ? 'date' : numberType ? 'number' : passwordType ? 'password' : 'text'}
            select={!!children}
            fullWidth
            variant={'filled'}
            multiline={multiline}
            minRows={minRows}
            InputLabelProps={isDate ? { shrink: true } : undefined}
            
            InputProps={{
                disableUnderline: true,
                inputProps: {
                    ...(numberType && { min: 1 }),
                    ...inputProps

                },
                ...(numberType && {
                    onWheel : (e) => {
                        e.target.blur()
                },
                }),
            }}
            onClick={isDate ? showDatePicker : undefined}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            sx={{
                backgroundColor: inputBoxColor,
                borderRadius: '6px',
                '& .MuiFilledInput-root': {
                    backgroundColor: inputBoxColor,
                    borderRadius: '6px',
                    '&:hover': { backgroundColor: inputBoxColor },
                    '&.Mui-focused': { backgroundColor: inputBoxColor },
                },
                '& input[type=number]': {
                    MozAppearance: 'textfield',
                },
                '& input[type=number]::-webkit-outer-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                },
                '& input[type=number]::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                },
            }}
        >
            {children}
        </TextField>
    );
};
